/* eslint-disable no-case-declarations */
import {
  SET_FAQS, FAQS_REQUEST_FAILED, SENDING_FAQS_REQUEST,
} from '../../types/Types';

/** @type { Object } default state */
const defaultState = {
  faqsData: '',
  isFaqsSending: false,
  faqsError: false,
  isFaqsSuccess: false,
};

/**
* dispatched the user data to the store
* @param  { Object } state  default state
* @param  { Object } action dispacthed action from middleware
*/
export default function getFaqs(state = defaultState, action = {}) {
  switch (action.type) {
    case SET_FAQS:
      const data = {};
      data.faqsData = action.faqsData;
      data.isFaqsSending = action.isFaqsSending;
      data.isFaqsSuccess = action.isFaqsSuccess;
      data.faqsError = action.faqsError;
      return { ...state, ...data };

    case SENDING_FAQS_REQUEST:
      const sendingRequest = {};
      sendingRequest.faqsData = action.faqsData;
      sendingRequest.isFaqsSending = action.isFaqsSending;
      sendingRequest.isFaqsSuccess = action.isFaqsSuccess;
      sendingRequest.faqsError = action.faqsError;
      return { ...state, ...sendingRequest };

    case FAQS_REQUEST_FAILED:
      const errors = {};
      errors.faqsData = action.faqsData;
      errors.isFaqsSending = action.isFaqsSending;
      errors.isFaqsSuccess = action.isFaqsSuccess;
      errors.faqsError = action.faqsError;
      errors.faqsMsg = action.faqsMsg;
      return { ...state, ...errors };
    default: return state;
  }
}
